module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7deb41099be6d77fb833fcdf6eb1f1e4.png";